module.exports = __webpack_public_path__ + "img/pill.e60e159.jpg";